import styledComponent from 'styled-components';

const StyledNewsImage = styledComponent.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default StyledNewsImage;
